
import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { EmployeesActivitiesModel, EmployeesListModel } from './employees-list.model';
import { EmployeesListService } from './employees-list.service';
import { EMPLOYEES_MARITAL_STATUS, EMPLOYEES_CHILDREN, EMPLOYEES_PROPERTY_TYPE, EMPLOYEES_WORKDAY, EMPLOYEES_CONTRACT_TYPE } from '../employees/const';
import { EmployeesListComponent } from './employees-list.component';
import { DummyComponent } from '../../shared/dummy.component';
import { consts } from '../../consts';
import { Utils } from '../../shared/utils';
import { EMPLOYEES_PREDEFINED_NAMES } from '../../models/personal/employees.model';
import { BankAccountBicsModel } from '../finanzas/bancos/bankaccountbics.model';
import { BankAccountService } from '../finanzas/bancos/bankaccount.service';
import { Option } from '../../shared/models/option.model';

@Component({
    selector: 'app-employees-form',
    templateUrl: './employees-form.component.html',
    styleUrls: ['./employees-form.component.css'],
    standalone: false
})
export class EmployeesFormComponent implements OnInit {
  employeesListModel: EmployeesListModel;
  selectedIndexTab: number = 0;
  uid: number = this.data.uid;
  basicos: boolean = false;
  profesionales: boolean = false;
  filteredAdminEmployees: Observable<[EmployeesListModel]>;
  ready: boolean = false;
  submitted: boolean = false;
  nameFormControl: UntypedFormControl;
  dniFormControl: UntypedFormControl;
  birthDateFormControl: UntypedFormControl;
  employeesMaritalStatus = Object.keys(EMPLOYEES_MARITAL_STATUS);
  employeesChildren = Object.keys(EMPLOYEES_CHILDREN);
  employeesProperyType = Object.keys(EMPLOYEES_PROPERTY_TYPE);
  employeesWorkDay = Object.keys(EMPLOYEES_WORKDAY);
  employeesContractType = Object.keys(EMPLOYEES_CONTRACT_TYPE);
  get employeesMaritalStatusOptions(): Option[] { return this.employeesMaritalStatus.map(m => ({ label: m, value: m })); }
  get employeesChildrenOptions(): Option[] { return this.employeesChildren.map(c => ({ label: c, value: c })); }
  get employeesProperyTypeOptions(): Option[] { return this.employeesProperyType.map(p => ({ label: p, value: p })); }
  get employeesWorkDayOptions(): Option[] { return this.employeesWorkDay.map(w => ({ label: w, value: w })); }
  get employeesContractTypeOptions(): Option[] { return this.employeesContractType.map(c => ({ label: c, value: c })); }
  hasTypeEmployees: boolean = true;
  hasToggleSelected: boolean = true;
  showFaceTab: boolean = false;
  dataSource: any[];
  empty: boolean;

  employeesActivities: EmployeesActivitiesModel[] = [];
  employeesActivitiesLoaded: boolean = false;
  bankAccountBics: BankAccountBicsModel[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dummy: DummyComponent,
    public employeesService: EmployeesListService,
    public dialogRef: MatDialogRef<EmployeesListComponent>,
    public snackBar: MatSnackBar,
    private bankAccountService: BankAccountService
  ) {
    this.employeesListModel = new EmployeesListModel();
    this.nameFormControl = new UntypedFormControl();
    this.dniFormControl = new UntypedFormControl();
    this.birthDateFormControl = new UntypedFormControl();
  }

  public setNewAccountNumber() {
    this.employeesService.getNewAccountNumber().then(response => {
      this.employeesListModel.accountingmodels_number = response;
    });
  }

  ngOnInit() {
    this.ready = false;
    this.employeesActivitiesLoaded = false;

    // Obtenemos los EmployeesActivities
    const employeeId = this.uid == null ? 0 : this.uid;
    this.employeesService.getEmployeesActivities(employeeId)
      .then(response => {
        this.ready = true;
        this.employeesActivitiesLoaded = true;
        this.employeesActivities = response;

        if (this.employeesActivities != null && this.employeesActivities.length === 1) {
          this.employeesActivities[0].percentage = 100;
        }
      });

    this.bankAccountService.getBics().then(response => {
      this.bankAccountBics = response;
    });

    // EDIT
    this.employeesListModel.uid = this.uid;
    if (this.uid != undefined && this.uid !== null) {
      this.ready = false;

      this.employeesService.loadData(this.uid).then(employeesListModel => {
        this.ready = true;

        this.employeesListModel = this.procesarDatosRecibidosKey(employeesListModel);
        this.dniFormControl.setValue(this.employeesListModel.dni || '');
        if (this.employeesListModel.name == "Empleados_Por_Trimestre" || this.employeesListModel.name == "Empleados_Por_Mes" || this.employeesListModel.name == "Empleados_Por_Año") {
          this.nameFormControl.disable()
          this.dniFormControl.disable();
        }
      });
    } else {
      this.ready = true;
      this.setNewAccountNumber();
    }
  }


  // SAVE
  public onSubmit() {
    if (this.dniFormControl.invalid) {
      this.dniFormControl.markAsTouched();
    }

    if (this.nameFormControl.invalid) {
      this.nameFormControl.markAsTouched();
    }

    this.isTypeContactValid();

    if (this.isDataValid() && this.hasTypeEmployees && this.hasToggleSelected) {
      this.employeesListModel.dni = this.dniFormControl.value;
      this.submitted = true;

      this.save(this.employeesListModel);
    } else {
      this.displayInfo("Compruebe los campos marcados en rojo");
      return;
    }
  }

  private isTypeContactValid() {

    if (EMPLOYEES_PREDEFINED_NAMES.includes(this.employeesListModel.name)) {
      this.hasTypeEmployees = true;
      return;
    }

    if (this.dniFormControl.value.length == 0 || (this.dniFormControl.value[0] === "" && this.dniFormControl.value[1] === "") || this.dniFormControl.value.length == 0) {
      this.hasTypeEmployees = false;
    } else {
      this.hasTypeEmployees = true;
    }
  }

  private isDataValid(): boolean {

    if (EMPLOYEES_PREDEFINED_NAMES.includes(this.employeesListModel.name)) {
      return true;
    }

    if (!this.dniFormControl.invalid && !this.nameFormControl.invalid) {
      return true;
    }
    return false;
  }

  public save(employeesListModel) {
    const employeesListModelProsecuted = this.procesarDatosRecibidos(employeesListModel);
    let noError = true;
    let mensajeError = '';

    if (employeesListModelProsecuted.dniFormControl == "") {
      noError = false;
      mensajeError = "Debe especificar el DNI";
    }


    let percentageSumTotal = 0;
    for (let i = 0; i < this.employeesActivities.length; i++) {
      percentageSumTotal += this.employeesActivities[i].percentage;
    }

    if (percentageSumTotal !== 100) {
      noError = false;
      mensajeError = "El total del porcentaje de las distintas actividades no puede ser distinta a 100";
    }

    // Le asignamos lo que el usuario fué metiendo en employeesActivities
    this.employeesListModel.employeesActivities = this.employeesActivities;

    if (noError) {
      if (employeesListModel.uid == null) {
        this.employeesService.addData(employeesListModelProsecuted)
          .then(employeesListModel => {
            this.employeesListModel = employeesListModelProsecuted;
            this.dialogRef.close(true);
          },
            error => this.displayInfo(error.error['message'])
          )
      } else {
        this.employeesService.editData(employeesListModel.uid, employeesListModel)
          .then(employeesListModel => {
            this.employeesListModel = employeesListModel;
            this.dialogRef.close(true);
          },
            error => this.displayInfo(error.error['message'])
          )
      }
    } else {
      this.displayInfo(mensajeError);
    }
  }

  closeDialog() {
    this.dialogRef.close(true);
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }

  // Función para procesar los datos a enviar y convertir las claves a valores correspondientes
  procesarDatosRecibidos(employeesListModel: any): any {
    const mappings = {
      children: EMPLOYEES_CHILDREN,
      contract_type: EMPLOYEES_CONTRACT_TYPE,
      property_type: EMPLOYEES_PROPERTY_TYPE,
      workday: EMPLOYEES_WORKDAY,
      marital_status: EMPLOYEES_MARITAL_STATUS,
    };

    for (const clave in employeesListModel) {
      if (employeesListModel.hasOwnProperty(clave) && mappings.hasOwnProperty(clave)) {
        employeesListModel[clave] = mappings[clave][employeesListModel[clave]];
      }
    }
    return employeesListModel;
  }

  // Función para procesar los datos a enviar y convertir los valores a claves correspondientes
  procesarDatosRecibidosKey(employeesListModel: any): any {
    const mappings = {
      children: EMPLOYEES_CHILDREN,
      contract_type: EMPLOYEES_CONTRACT_TYPE,
      property_type: EMPLOYEES_PROPERTY_TYPE,
      workday: EMPLOYEES_WORKDAY,
      marital_status: EMPLOYEES_MARITAL_STATUS,
    };

    for (const clave in employeesListModel) {
      if (employeesListModel.hasOwnProperty(clave) && mappings.hasOwnProperty(clave)) {
        const mappedValue = employeesListModel[clave];
        const key = Object.keys(mappings[clave]).find(k => mappings[clave][k] === mappedValue);
        if (key !== undefined) {
          employeesListModel[clave] = key;
        }
      }

    }
    return employeesListModel;
  }

  changeToggleType(event: MatSlideToggleChange, element: string) {
    if (element == "isActive") {
      this.employeesListModel.active = event.checked;
      this.hasToggleSelected = true;
    }
    this.showFaceTab = true;
  }
  public trackByIndex(i: number) { return i; }

}

